import apiClient from '../../../services/api'; // <-- Import client tập trung

const USER_ENDPOINT = '/users';

const getProfile = async (config = {}) => {
  // Trình duyệt tự động gửi cookie, chúng ta chỉ cần gọi API
  const response = await apiClient.get(`${USER_ENDPOINT}/profile`, config);
  return response.data;
};

const updateProfile = async (profileData) => {
  const response = await apiClient.put(`${USER_ENDPOINT}/profile`, profileData);
  return response.data;
};

const changePassword = async (passwordData) => {
  const response = await apiClient.put(`${USER_ENDPOINT}/change-password`, passwordData);
  return response.data;
};

// Upload avatar (multipart/form-data)
const uploadAvatar = async (file) => {
  const formData = new FormData();
  formData.append('avatar', file);
  const response = await apiClient.post(`${USER_ENDPOINT}/avatar`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// Get wallet balance
const getWallet = async () => {
  const response = await apiClient.get(`${USER_ENDPOINT}/wallet`);
  return response.data;
};

// Send verification email with OTP (auth service backend usually)
const sendEmailVerification = async () => {
  const response = await apiClient.post('/auth/resend-verification');
  return response.data;
};

// Verify email with OTP
const verifyEmail = async (payload) => {
  const response = await apiClient.post('/auth/verify-email', payload);
  return response.data;
};

export const userService = {
  getProfile,
  updateProfile,
  changePassword,
  uploadAvatar,
  getWallet,
  sendEmailVerification,
  verifyEmail,
};